const faqItems = [
  {
    q: '爆料网的内容来源是什么？',
    a: '爆料网汇聚来自911爆料网、51爆料网、91爆料网等主流爆料平台的一手信息，同时接受匿名用户的独家投稿。我们的编辑团队会对每条内容进行多源交叉验证，确保信息的新鲜度与可信度。所有内容均来自公开可查的信息渠道或匿名投递，不涉及非法信息采集。',
  },
  {
    q: '如何在爆料网上投稿？',
    a: '你可以通过本页面的"联系投稿"入口或直接发送邮件至我们的匿名投稿通道。我们承诺对投稿人信息严格保密，所有投稿均采用加密传输，不保留任何可追溯个人身份的信息。收到投稿后，编辑团队会在24小时内完成审核并决定是否发布。',
  },
  {
    q: '爆料网的内容多久更新一次？',
    a: '爆料网实行全天候实时更新机制。编辑团队7×24小时轮值监控各大爆料平台和社交媒体的最新动态，重点猛料从发现到上架通常在30分钟以内。同时，每日固定时段会进行内容汇总和深度追踪更新，确保你看到的每一条信息都是最新的。',
  },
  {
    q: '爆料网上的信息可信吗？',
    a: '我们坚持"多源交叉验证"原则。每一条发布于爆料网的内容，都至少经过两个独立信源的确认。对于无法完全验证的信息，我们会明确标注"待核实"标签。同时，我们也欢迎读者在评论区提供补充信息或指正，共同维护平台信息的真实性与公信力。',
  },
  {
    q: '使用爆料网是否需要付费？',
    a: '爆料网目前全部内容对用户免费开放。你可以自由浏览所有焦点专题、吃瓜视频、独家追踪等内容。APP下载也完全免费。未来如果推出增值服务，我们会提前公告并确保基础内容始终免费可用。我们通过广告和品牌合作维持运营，不会向用户收费。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-8 md:mb-10">
          常见问题
        </h2>

        <div className="space-y-0">
          {faqItems.map((item, i) => (
            <div key={i} className="py-5 md:py-6 border-b border-background-200 last:border-b-0">
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2.5">{item.q}</h3>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}